import axios from "config/axios";
import { handleAxiosResponseError } from "utils/handleResponseError";

export const getAdmins = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/admin`)
    .then(({ data }) => {
      return data?.admin;
    });
};

export const postAdmin = (postData) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/admin/signup`, postData)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const addAdminToSuperintendent = (postdata) => {
  return axios
    .put(
      `${process.env.REACT_APP_SERVER_URL}/api/admin/superintendent`,
      postdata,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteAdmin = (deleteData) => {
  return axios
    .post(
      `${process.env.REACT_APP_SERVER_URL}/api/admin/${deleteData._id}`,
      deleteData,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const updateAdmin = (updateData) => {
  return axios
    .put(
      `${process.env.REACT_APP_SERVER_URL}/api/auth/updateadmin/${updateData.id}`,
      updateData.data,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getSubAdmins = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/subadmin`)
    .then(({ data }) => {
      return data?.admin?.sort((a, b) =>
        a?.firstName?.toLocaleLowerCase() > b?.firstName?.toLocaleLowerCase()
          ? 1
          : -1,
      );
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteSubAdmin = (data) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/subadmin/${data._id}`, data)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const postSubAdmin = (postData) => {
  if (postData.type === "subadmin")
    return axios
      .post(
        `${process.env.REACT_APP_SERVER_URL}/api/auth/subadmin/signup`,
        postData.data,
      )
      .then(({ data }) => {
        return data;
      })
      .catch((err) => {
        return { error: handleAxiosResponseError(err) };
      });
  else if (postData.type === "secretary")
    return axios
      .post(
        `${process.env.REACT_APP_SERVER_URL}/api/secretary/signup`,
        postData,
      )
      .then(({ data }) => {
        return data;
      })
      .catch((err) => {
        return { error: handleAxiosResponseError(err) };
      });
  else if (postData.type === "assistprincipal")
    axios
      .post(
        `${process.env.REACT_APP_SERVER_URL}/api/assistantprincipal/signup`,
        postData,
      )
      .then(({ data }) => {
        return data;
      })
      .catch((err) => {
        return { error: handleAxiosResponseError(err) };
      });
  else
    return axios
      .post(`${process.env.REACT_APP_SERVER_URL}/api/generaluser`, postData)
      .then(({ data }) => {
        return data;
      })
      .catch((err) => {
        return { error: handleAxiosResponseError(err) };
      });
};

export const updateCrmUser = (postdata) => {
  if (postdata?.type === "data")
    return axios
      .put(
        `${process.env.REACT_APP_SERVER_URL}/api/auth/admin/update/${postdata.id}`,
        postdata.data,
      )
      .then(({ data }) => {
        return data;
      })
      .catch((err) => {
        return { error: handleAxiosResponseError(err) };
      });
  else
    return axios
      .put(
        `${process.env.REACT_APP_SERVER_URL}/api/auth/admin/current/profile?id=${postdata.id}`,
        {
          image: postdata.data,
        },
      )
      .then(({ data }) => {
        return data;
      })
      .catch((err) => {
        return { error: handleAxiosResponseError(err) };
      });
};

export const getSecretaries = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/secretary`)
    .then(({ data }) => {
      return data?.admin?.sort((a, b) =>
        a?.firstName?.toLocaleLowerCase() > b?.firstName?.toLocaleLowerCase()
          ? 1
          : -1,
      );
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getAssistantPrincipals = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/assistantprincipal`)
    .then(({ data }) => {
      return data?.admin?.sort((a, b) =>
        a?.firstName?.toLocaleLowerCase() > b?.firstName?.toLocaleLowerCase()
          ? 1
          : -1,
      );
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getGeneralUsers = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/generaluser`)
    .then(({ data }) => {
      return data?.admin?.sort((a, b) =>
        a?.firstName?.toLocaleLowerCase() > b?.firstName?.toLocaleLowerCase()
          ? 1
          : -1,
      );
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteGeneralUser = (postdata) => {
  return axios
    .delete(
      `${process.env.REACT_APP_SERVER_URL}/api/generalUser/${postdata._id}`,
      postdata,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteSecretary = (postdata) => {
  return axios
    .delete(
      `${process.env.REACT_APP_SERVER_URL}/api/secretary/${postdata._id}`,
      postdata,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteAssistPrincipal = (postdata) => {
  return axios
    .delete(
      `${process.env.REACT_APP_SERVER_URL}/api/assistprincipal/${postdata._id}`,
      postdata,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const postSpecialRole = (postdata) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/specialrole`, postdata)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const postSecretaryRole = (postdata) => {
  return axios
    .post(
      `${process.env.REACT_APP_SERVER_URL}/api/specialsecretaryrole`,
      postdata,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getSpecialRoles = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/specialrole`)
    .then(({ data }) => {
      return data?.roles;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getSpecialSecretaryRoles = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/specialsecretaryrole`)
    .then(({ data }) => {
      return data?.roles;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getSpecialUsers = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/specialuser`)
    .then(({ data }) => {
      return data?.users;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const postSpecialUser = (postdata) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/specialuser`, postdata)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteSpecialUser = (data) => {
  return axios
    .delete(`${process.env.REACT_APP_SERVER_URL}/api/specialuser/${data._id}`)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getSpecialSecretary = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/specialsecretary`)
    .then(({ data }) => {
      return data?.users;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getSuperintendents = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/superintendents`)
    .then(({ data }) => {
      return data?.admins?.sort((a, b) =>
        a?.firstName?.toLocaleLowerCase() > b?.firstName?.toLocaleLowerCase()
          ? 1
          : -1,
      );
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getRoles = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/roles`)
    .then(({ data }) => {
      return data?.roles;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getNotes = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/notestatus`)
    .then(({ data }) => {
      return data?.notes;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const postSpecialSecretary = (postdata) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/specialsecretary`, postdata)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const postRoles = (postdata) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/roles`, postdata)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const postSuperintendents = (postdata) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/superintendents`, postdata)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteSpecialSecretary = (data) => {
  return axios
    .delete(
      `${process.env.REACT_APP_SERVER_URL}/api/specialsecretary/${data._id}`,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteSuperintendent = (data) => {
  return axios
    .delete(
      `${process.env.REACT_APP_SERVER_URL}/api/superintendents/${data._id}`,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteRole = (data) => {
  return axios
    .delete(`${process.env.REACT_APP_SERVER_URL}/api/roles/${data._id}`)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteSpecialRole = (data) => {
  return axios
    .delete(`${process.env.REACT_APP_SERVER_URL}/api/specialroles/${data._id}`)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteSecretaryRole = (data) => {
  return axios
    .delete(
      `${process.env.REACT_APP_SERVER_URL}/api/specialsecretaryrole/${data._id}`,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getCalendarUsers = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/calendar/users`)
    .then(({ data }) => {
      return data?.users?.sort((a, b) =>
        a?.firstName?.toLocaleLowerCase() > b?.firstName?.toLocaleLowerCase()
          ? 1
          : -1,
      );
    })
    .catch((err) => {
      console.log(handleAxiosResponseError(err));
    });
};

export const getCampusInfo = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/campus`)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      console.log(handleAxiosResponseError(err));
    });
};

export const getFocusSheet = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/campus/focussheet`)
    .then(({ data }) => {
      return data?.focusSheet;
    })
    .catch((err) => {
      console.log(handleAxiosResponseError(err));
    });
};

export const postCampus = (postdata) => {
  return axios
    .put(`${process.env.REACT_APP_SERVER_URL}/api/campus`, postdata)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const postFocusSheet = (postdata) => {
  return axios
    .put(`${process.env.REACT_APP_SERVER_URL}/api/campus/focussheet`, postdata)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getTodos = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/todo`)
    .then(({ data }) => {
      const tod = data.todos;
      return tod.map((td, index) => ({ ...td, index }));
    })
    .catch((err) => {
      console.log(handleAxiosResponseError(err));
    });
};

export const postTodos = (postdata) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/todo`, postdata)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getArchiveTodos = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/todo/archiveTodo`)
    .then(({ data }) => {
      return data?.todos;
    })
    .catch((err) => {
      console.log(handleAxiosResponseError(err));
    });
};

export const deleteArchiveTodos = (id) => {
  return axios
    .delete(
      `${process.env.REACT_APP_SERVER_URL}/api/todo/archiveTodo/${id?._id ? id._id : id}`,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const unArchiveTodos = (postData) => {
  return axios
    .delete(
      `${process.env.REACT_APP_SERVER_URL}/api/todo/archiveTodo/${postData._id}`,
    )
    .then(() => {
      delete postData._id;
      return axios
        .post(`${process.env.REACT_APP_SERVER_URL}/api/todo`, postData)
        .then(({ data }) => {
          return data;
        })
        .catch((err) => {
          return { error: handleAxiosResponseError(err) };
        });
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const getEvents = ({ queryKey }) => {
  // console.log(queryKey)
  // eslint-disable-next-line
  const [_, token] = queryKey;
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/calendar?token=${token}`)
    .then(({ data }) => {
      return data?.events;
    })
    .catch((err) => {
      console.log(handleAxiosResponseError(err));
    });
};

export const getNameEvents = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/event/id`)
    .then(({ data }) => {
      return data?.events;
    })
    .catch((err) => {
      console.log(handleAxiosResponseError(err));
    });
};

export const getWalkthroughUsers = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/walkthrough/users`)
    .then(({ data }) => {
      return data?.admin ? data.admin : data.users;
    })
    .catch((err) => {
      console.log(handleAxiosResponseError(err));
    });
};
export const getWalkthroughs = () => {
  return axios
    .get(`${process.env.REACT_APP_SERVER_URL}/api/walkthrough`)
    .then(({ data }) => {
      return data?.walks;
    })
    .catch((err) => {
      console.log(handleAxiosResponseError(err));
    });
};

export const postWalkthroughs = (data) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/walkthrough`, data)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const updateWalkthroughs = (postData) => {
  return axios
    .put(
      `${process.env.REACT_APP_SERVER_URL}/api/walkthrough/${postData.id}`,
      postData.data,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteWalkthroughs = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_SERVER_URL}/api/walkthrough/${id}`)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const updateWalkthroughView = (postData) => {
  return axios
    .put(
      `${process.env.REACT_APP_SERVER_URL}/api/walkthrough/updateview/${postData.id}`,
      { firstView: postData.firstView },
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const postEvents = (data) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/calendar`, data)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteTodo = (data) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/todo/archiveTodo`, data)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const updateTodo = (postData) => {
  return axios
    .put(
      `${process.env.REACT_APP_SERVER_URL}/api/todo/${postData.id}`,
      postData.data,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const updateTodoOrder = (postData) => {
  return axios
    .put(`${process.env.REACT_APP_SERVER_URL}/api/todo/updateorder`, postData)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const deleteEvents = (deleteData) => {
  return axios
    .post(`${process.env.REACT_APP_SERVER_URL}/api/calendar/delete`, deleteData)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const updateEvents = (postData) => {
  return axios
    .put(`${process.env.REACT_APP_SERVER_URL}/api/calendar`, postData)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const postProfessional = (data) => {
  return axios
    .post(
      `${process.env.REACT_APP_SERVER_URL}/api/calendar/professional`,
      data.updateUser,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};

export const updateProfessional = (data) => {
  return axios
    .put(
      `${process.env.REACT_APP_SERVER_URL}/api/calendar/professional/${data.id}`,
      data.updateUser,
    )
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      return { error: handleAxiosResponseError(err) };
    });
};
